module.exports = __webpack_public_path__ + "images/般蓝pr长图_01.jpg?v=a929601d";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图_01.jpg
 ** module id = 178
 ** module chunks = 1 2
 **/